import {date as dateTools} from '@rocket-ui/tools';
import {CellContext} from '@tanstack/react-table';
import React, {FC} from 'react';

type DateCellProps = CellContext<any, string | Date>;

export interface DateCellSubmodules {
	nullable: typeof NullableDateCell;
	customFormat: typeof FormattedDateCell;
}

export const DateTimeCell: FC<DateCellProps> & DateCellSubmodules = ({getValue}) => {
	const value = getValue();
	const date = value instanceof Date ? value : new Date(value);

	return <div>{dateTools.format(date)}</div>;
};

type NullableDateCellProps = CellContext<any, Date | string | undefined>;

const NullableDateCell = (placeholder: string): FC<NullableDateCellProps> => {
	return (props: NullableDateCellProps) => {
		if (!props.getValue()) return <>{placeholder}</>;

		return <DateTimeCell {...(props as DateCellProps)} />;
	};
};

const FormattedDateCell = (format: string): FC<DateCellProps> => {
	return (props: DateCellProps) => {
		const value = props.getValue();
		const date = value instanceof Date ? value : new Date(value);

		return <>{dateTools.format(date, format)}</>;
	};
};

DateTimeCell.nullable = NullableDateCell;
DateTimeCell.customFormat = FormattedDateCell;
